//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatConfiguredTime } from '../../components/helpers.js'
import WaybillFlightPhotos from '../Waybill/WaybillFlightPhotos.vue'

export default {
  components: {
    WaybillFlightPhotos
  },
  props: {
    reports: {
      type: Array,
      default: () => null
    },
    category: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      selectedReport: null,
      photosFromReportsIds: {},

      formatConfiguredTime
    }
  },
  computed: {
    selectedReportPhotos: function () {
      return this.getReportPhotos(this.selectedReport)
    },
    selectedPhotosAmount: function () {
      return Object.values(this.photosFromReportsIds).reduce((acc, current) => {
        return acc + (current ? current.length : 0)
      }, 0)
    }
  },
  watch: {
    reports: {
      handler: function (value) {
        if (value) {
          this.selectedReport = value[0]
        }
      },
      immediate: true
    }
  },
  created: function () {
    const categoryDocumentsIds = this.category.files
      .filter(file => file.document.selectedFromReport)
      .map(file => file.id)
    this.reports.forEach(report => {
      const selectedDocuments = []
      report.documents.forEach(document => {
        if (categoryDocumentsIds.includes(document.id)) {
          selectedDocuments.push(document.id)
        }
      })
      this.$set(this.photosFromReportsIds, report.id, selectedDocuments)
    })
  },
  methods: {
    getReportPhotos: function (report) {
      const reportDocumentsIds = []
      if (report) {
        report.documents.forEach(document => {
          if (report.activePhotoCategories.includes(document.category)) {
            reportDocumentsIds.push(document.id)
          }
        })

        // Убираем одинаковые фото
        const uniqueDocumentsIds = [...new Set(reportDocumentsIds)]

        const currentDocumentsIds = this.category ? this.category.files.map(file => file.document.id) : []

        return uniqueDocumentsIds.map(documentId => {
          return {
            url: '/service/delta/document/read?id=' + documentId,
            name: documentId + ', ' + new Date().toLocaleString(),
            id: documentId,
            selectable: !currentDocumentsIds.includes(documentId) || this.category.files.find(file => file.id === documentId).document.selectedFromReport
          }
        })
      } else {
        return []
      }
    },
    onSelectPhoto: function (value) {
      this.$set(this.photosFromReportsIds, this.selectedReport.id, value)
    },
    onSave: function () {
      this.$emit('save', Object.values(this.photosFromReportsIds)
        .flat()
        .filter(id => {
          const alreadySelectedFile = this.category.files.find(file => file.id === id)
          return !alreadySelectedFile || alreadySelectedFile.document.selectedFromReport
        }))
    },
    onCancel: function () {
      this.$emit('cancel')
    }
  }
}

